import React from "react";
import { Lock, Eye, Download, Trash2 } from "lucide-react";
import Reveal from "@/components/Reveal";

const items = [
  {
    icon: Lock,
    title: "Encrypted in transit & at rest",
    body: "Your receipts and expense details are encrypted and stored with least-privilege access.",
  },
  {
    icon: Eye,
    title: "We never sell your data",
    body: "No selling or renting of personal or health-related information to third parties. Ever.",
  },
  {
    icon: Download,
    title: "Export anytime",
    body: "Download clean summaries of your own records whenever you want, in a format your tax pro can use.",
  },
  {
    icon: Trash2,
    title: "Delete anytime",
    body: "Ask us to delete your account and data, and we will. Email info@countedcare.com.",
  },
];

export default function DataControl() {
  return (
    <section id="data-control" className="mx-auto max-w-7xl px-4 py-12">
      <Reveal className="max-w-2xl">
        <h2 className="text-2xl md:text-3xl font-semibold text-slate-900">
          Your data, your control
        </h2>
        <p className="mt-2 text-slate-600">
          Caregiving records are personal. Here is exactly how we treat yours.
        </p>
      </Reveal>
      <Reveal className="stagger-reveal mt-8 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {items.map(({ icon: Icon, title, body }) => (
          <div
            key={title}
            className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm"
          >
            <Icon className="h-5 w-5 text-sky-700" aria-hidden="true" />
            <h3 className="mt-3 text-base font-medium text-slate-900">{title}</h3>
            <p className="mt-1 text-sm text-slate-600">{body}</p>
          </div>
        ))}
      </Reveal>
      <Reveal delay={100} className="mt-4 text-xs text-slate-500">
        Read the full{" "}
        <a href="/privacy-policy" className="underline hover:text-slate-700">
          Privacy Policy
        </a>{" "}
        and{" "}
        <a href="/terms-and-conditions" className="underline hover:text-slate-700">
          Terms
        </a>
        .
      </Reveal>
    </section>
  );
}
